/* eslint-disable no-param-reassign */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Select, Table } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import H3Image from '@Uilib/h3Image';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import imageDefault from '@Images/icons/imageDefault.png';
import SelectUOM from '@Components/Admin/Common/SelectUOM';
import ProductFilterV2 from '@Components/Common/ProductFilterV2';
import './style.scss';
import ProductCategoryLabel from '../../../../Common/ProductCategoryLabel';
import PRZSelect from '../../../../Common/UI/PRZSelect';
/**
 *
 */
class PurchaseRequestLines extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      listColumns: [
        {
          title: '',
          key: 'asset1',
          render: (text, record) => (
            <div style={{ width: '30px' }}>
              <H3Image src={record?.asset1 || imageDefault} className="pr-table__image" style={{ opacity: record?.asset1 ? 1 : 0.1 }} />
            </div>
          ),
          width: '60px',
        },
        {
          title: 'PRODUCT',
          width: '240px',
          render: (text, record) => {
            const {
              handleProductChangeValue, handleProductChange, formSubmitted, data, selectedTenant,
            } = this.props;
            return (
              <div className="pr-table__product-name">

                <ProductFilterV2
                  record={record}
                  productTypes={['STORABLE', 'SERVICE']}
                  handleProductChangeValue={handleProductChangeValue}
                  handleProductChange={handleProductChange}
                  isPurchaseProduct
                  required
                  showError={formSubmitted && !record.product_sku_name}
                  onClear={(key) => {
                    const { updateData } = this.props;
                    const copyData = JSON.parse(JSON.stringify(data));
                    const updatedData = copyData.map((item) => {
                      if (item.key === key) {
                        return {
                          key: uuidv4(),
                          asset1: '',
                          product_sku_name: '',
                          uomGroup: null,
                          purchase_requisition_id: null,
                          product_sku_info: null,
                          product_sku_id: null,
                        };
                      }
                      return {
                        ...item,
                      };
                    });
                    updateData(updatedData);
                  }}
                  disabled={record?.product_sku_id}
                  excludedProducts={data.map((item) => JSON.stringify(item?.tenant_product_id)) || []}
                  selectedTenant={selectedTenant}
                  showClear
                />
                {record?.product_category_info?.category_path?.length > 0 && (
                  <ProductCategoryLabel
                    categoryPath={record?.product_category_info?.category_path}
                    categoryName={record?.product_category_info?.category_path?.at(
                      -1
                    )}
                    containerStyle={{
                      width: "fit-content",
                    }}
                  />
                )}
                <textarea
                  value={record.remark}
                  onChange={(e) => {
                    const { updateData } = this.props;
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.map((item) => {
                      if (item.key === record.key) {
                        item.remark = e.target.value;
                      }
                      return data;
                    });
                    updateData(copyData);
                  }}
                  className="pr-table__remarks"
                  placeholder="Add description of this item.."
                />
              </div>
            );
          },
        },
        {
          title: 'QUANTITY',
          dataIndex: 'quantity',
          width: '150px',
          render: (text, record) => {
            const { formSubmitted } = this.props;
            return (
              <div>
                <H3FormInput
                  value={record.quantity}
                  type="number"
                  containerClassName={`orgInputContainer ${(formSubmitted && Number(record.quantity) <= 0) ? 'create-pr__input' : ''}`}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(e) => {
                    const { data, updateData } = this.props;
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.map((item) => {
                      if (item.key === record.key) {
                        item.quantity = e.target.value;
                      }
                      return data;
                    });
                    updateData(copyData);
                  }}
                />
                {record?.vendorMoq && <H3Text text={`Vendor MOQ is ${record?.vendorMoq}`} className="table-subscript" />}
              </div>
            );
          },
        },
        {
          title: 'UNIT',
          width: '120px',
          render: (text, record) => {
            const { formSubmitted } = this.props;
            return (
              <div style={{ width: '120px' }}>
                {record?.tenant_product_id ? (
                  <div className="orgInputContainer">
                    <PRZSelect
                      filterOption={false}
                      className=""
                      value={record?.uomId}
                      onChange={(value) => {
                        const { data, updateData } = this.props;
                        const copyData = JSON.parse(JSON.stringify(data));
                        copyData.map((item) => {
                          if (item.key === record.key) {
                            item.uomId = value;
                            item.uom_id = value;
                            item.uom_info = item?.uom_list?.find((rec) => rec?.uom_id === value);
                          }
                          return item;
                        });
                        updateData(copyData);
                      }}
                    >
                      {
                        record?.uom_list?.map((uom) => (
                          <Option key={uom?.uom_id} value={uom?.uom_id}>{`${uom?.uqc?.toProperCase()} (${uom?.uom_name?.toProperCase()})`}</Option>
                        ))
                      }
                    </PRZSelect>
                  </div>
                ) : (
                  <div className="orgInputContainer">
                    <SelectUOM
                      onChange={(value) => {
                        const { data, updateData } = this.props;
                        const copyData = JSON.parse(JSON.stringify(data));
                        copyData.map((item) => {
                          if (item.key === record.key) {
                            item.uom_id = value?.uom_id;
                            item.uomId = value?.uom_id;
                            item.uom_info = value;
                          }
                          return item;
                        });
                        updateData(copyData);
                      }}
                      errorOutline={formSubmitted && !record?.uom_id}
                      selectedUom={record.uom_id}
                      hideTitle
                      uomGroup={record.uomGroup}
                    />
                  </div>
                )}
                {record?.vendorMoq && <H3Text text={<div>&nbsp;</div>} className="table-subscript" />}
              </div>
            );
          },
        },
        {
          title: 'TARGET PRICE',
          width: '250px',
          render: (text, record) => {
            const { formSubmitted, targetPriceMandatory } = this.props;
            return (
              <div>
                <H3FormInput
                  value={record.targetPrice}
                  type="number"
                  containerClassName={`orgInputContainer ${(formSubmitted && targetPriceMandatory && Number(record.targetPrice || 0) <= 0) ? 'create-pr__input' : ''}`}
                  labelClassName="orgFormLabel"
                  inputClassName="orgFormInput"
                  onChange={(e) => {
                    const { data, updateData } = this.props;
                    const copyData = JSON.parse(JSON.stringify(data));
                    copyData.map((item) => {
                      if (item.key === record.key) {
                        item.targetPrice = e.target.value;
                      }
                      return data;
                    });
                    updateData(copyData);
                  }}
                />
                <div className="table-inline-description">
                  {record.maxPrice && (
                    <div className="table-subscript">
                      Max Price :
                      {'  '}
                      {this.props.MONEY(record.maxPrice || 0)}
                    </div>
                  )}
                  {record.minPrice && (
                    <div className="table-subscript">
                      Min Price :
                      {'  '}
                      {this.props.MONEY(record.minPrice || 0)}
                    </div>
                  )}

                </div>

              </div>
            );
          },
        },
        // {
        //   title: 'REMARKS',
        //   dataIndex: 'remarks',
        //   width: '300px',
        //   render: (text, record) => (
        //     <div>
        //       <H3FormInput
        //         value={record.remarks}
        //         type="text"
        //         containerClassName="orgInputContainer"
        //         labelClassName="orgFormLabel"
        //         inputClassName="orgFormInput"
        //         onChange={(e) => {
        //           const { data, updateData } = this.props;
        //           const copyData = JSON.parse(JSON.stringify(data));
        //           copyData.map((item) => {
        //             if (item.key === record.key) {
        //               item.remarks = e.target.value;
        //             }
        //             return data;
        //           });
        //           updateData(copyData);
        //         }}
        //         maxlength="256"
        //       />
        //     </div>
        //   ),
        // },
        {
          title: '',
          render: (text, record) => {
            const { handleDelete, data } = this.props;
            return (
              <Fragment>
                {data.length !== record.key && (
                  <div className="update-pr__delete-line-button" onClick={() => handleDelete(record.key)}>
                    <CloseOutlined />
                  </div>
                )}
              </Fragment>
            );
          },
          width: '40px',
        },
      ],
    };
  }

  /**
   *
   */
  componentDidMount() {
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      data,
    } = this.props;
    const {
      listColumns,
    } = this.state;
    return (
      <Fragment>
        <Table
          bordered
          showHeader
          size="small"
          scroll="scroll"
          columns={listColumns}
          dataSource={data}
          pagination={false}
        />
      </Fragment>
    );
  }
}

/**
 *
 * @param UserReducers
 * @param PurchaseOrderReducers
 * @return {{updateCustomPurchaseOrderLoading: *, selectedPurchaseOrder, user}}
 */
const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
});

/**
 *
 * @return {{}}
 */
const mapDispatchToProps = () => ({

});

PurchaseRequestLines.propTypes = {
  updateCustomPurchaseOrderLoading: PropTypes.bool,
  handleProductChangeValue: PropTypes.func,
  handleProductChange: PropTypes.func,
  handleDelete: PropTypes.func,
  updateData: PropTypes.func,
  data: PropTypes.any,
  formSubmitted: PropTypes.bool,
  targetPriceMandatory: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseRequestLines));
